// extracted by mini-css-extract-plugin
module.exports = {"Results":"schemes_Results__hp_lj","result":"schemes_result__VhHWD","Background":"schemes_Background__UmEKW","Container":"schemes_Container__iLx9_"};